import React from "react";
import { Paper, Box, Typography, IconButton, Button } from "@material-ui/core";
import { MoreVert, ArrowForward } from "@material-ui/icons";
import { Can } from "../../../components/Can";
import ChannelIcon from "../../../components/ChannelIcon";

/**
 * Tarjeta de un formulario web (doc 0417 §8) — vive en la MISMA grilla que
 * `ConnectionCard`, reutilizando sus mismas clases (`connectionCard`,
 * `cardHeader`, `connectionInfo`, etc. de `useConnectionsStyles`), pero NO
 * es una conexión: sin QR, sin estado CONNECTED/DISCONNECTED, sin
 * "Reconectar" — sus acciones propias son Editar/Pausar/Menú.
 */
const WebFormCard = ({ webForm, classes, theme, user, formatDateTime, onEdit, onMenuOpen }) => (
  <Paper className={classes.connectionCard}>
    <Box className={classes.cardHeader} display="flex" alignItems="flex-start">
      <ChannelIcon provider="webform" size={48} className={classes.whatsappIcon} />
      <Box className={classes.connectionInfo}>
        <Typography className={classes.connectionName}>{webForm.name}</Typography>
        <Box style={{ marginTop: theme.spacing(1) }}>
          <Box className={classes.connectionDetail}>
            <span className={classes.detailLabel}>Estado:</span>
            <span className={classes.detailValue}>
              {webForm.status === "activo" ? "Activo" : "Pausado"}
            </span>
          </Box>
          {webForm.tagName && (
            <Box className={classes.connectionDetail}>
              <span className={classes.detailLabel}>Etiqueta:</span>
              <span className={classes.detailValue}>{webForm.tagName}</span>
            </Box>
          )}
          {webForm.updatedAt && (
            <Box className={classes.connectionDetail}>
              <span className={classes.detailLabel}>Fecha:</span>
              <span className={classes.detailValue}>{formatDateTime(webForm.updatedAt)}</span>
            </Box>
          )}
          <Box className={classes.connectionDetail}>
            <span className={classes.detailLabel}>Conexión:</span>
            <span className={classes.detailValue}>Formulario Web</span>
          </Box>
        </Box>
      </Box>
      <Can
        role={user.profile}
        perform="connections-page:editOrDeleteConnection"
        yes={() => (
          <IconButton className={classes.menuButton} onClick={e => onMenuOpen(e, webForm)} size="small">
            <MoreVert />
          </IconButton>
        )}
      />
    </Box>
    <Box className={classes.cardBody}>
      <Can
        role={user.profile}
        perform="connections-page:actionButtons"
        yes={() => (
          <Button className={classes.actionButton} onClick={() => onEdit(webForm)} endIcon={<ArrowForward />} fullWidth>
            Editar
          </Button>
        )}
      />
    </Box>
  </Paper>
);

export default WebFormCard;
